<template>
    <div class=" col-md-4 border-0">
        <div class="ibox dasboard_graph dashboard_dough">
            <div class="ibox-title dashboard_title company-form-box-title pf-contribution">
                <div class="clearfix">
                    <div class="left_container">
                        <ul class="title_list">
                            <li class="title-text">Payroll  Breakdown</li>
                        </ul>
                    </div>
                    <div class="right_container">
                        <template v-if="payrunsfiscalyear.length > 0">
                            <b-form-select class="dasboard_graph_select" v-model="search_doughnut.fiscal_year"  @change="setSearchDoughnut()">
                                <option value="null">Select Fiscal Year</option>
                                <option v-for='fyear in payrunsfiscalyear' :value='fyear.fiscal_year'  >{{fyear.fiscal_year }}</option>
                            </b-form-select>
                            <b-form-select class="dasboard_graph_select"  v-model="search_doughnut.month" @change="setSearchDoughnut()">
                                <template v-for='fmonth in payrunsfiscalmonth'>
                                    <template v-if="fmonth == 'July' ||  fmonth == 'August' ||  fmonth == 'September' ||  fmonth == 'October' || fmonth == 'November' || fmonth == 'December' ">
                                        <option  :value='fmonth' >{{fmonth }} {{year_segment1}}</option>
                                    </template>
                                    <template v-else>
                                        <option  :value='fmonth' >{{fmonth }} {{year_segment2}}</option>
                                    </template>
                                </template>
                            </b-form-select>
                        </template>
                    </div>

                </div>
            </div>
            <div class="ibox-content pt-0">
                <template v-if="doughnutDatas != null">
                    <div class="chart-container-wrapper row  d-flex align-items-center">
                        <div class="col-md-6">
                            <div class="chart-container pie-chart dashboard_dough_grapg">
                                <doughnut-chart :chart-data="doughnutDatas" :options= "options_doughnut" :styles="myStyles_doughnut"  class="pb-3"></doughnut-chart>
                            </div>
                        </div>
                        <div class="col-md-6 text-left">
                            <div class="analysis-blocks-wrapper">
                                <div class="analysis-blocks d-flex align-items-center">

                                    <div class="analysis-blocks-circle basic"></div>
                                    <div class="analysis-blocks-contents align-items-center">
                                        <div class="tile"><span>Basic Salary</span></div>
                                        <div class="value"><span>{{ analysis_percentages.basic }}%</span></div>
                                    </div>
                                </div>
                                <div class="analysis-blocks d-flex align-items-center">
                                    <div class="analysis-blocks-circle house"></div>
                                    <div class="analysis-blocks-contents align-items-center">
                                        <div class="tile"><span>House Rent Allowance</span></div>
                                        <div class="value"><span>{{ analysis_percentages.house }}%</span></div>
                                    </div>
                                </div>
                                <div class="analysis-blocks d-flex align-items-center">
                                    <div class="analysis-blocks-circle medical"></div>
                                    <div class="analysis-blocks-contents align-items-center">
                                        <div class="tile"><span>Medical Allowance</span></div>
                                        <div class="value"><span>{{ analysis_percentages.medical }}%</span></div>
                                    </div>
                                </div>
                                <div class="analysis-blocks d-flex align-items-center">
                                    <div class="analysis-blocks-circle pf"></div>
                                    <div class="analysis-blocks-contents align-items-center">
                                        <div class="tile"><span>PF Contribution</span></div>
                                        <div class="value"><span>{{ analysis_percentages.pf }}%</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </template>

                 <template v-else>
                    <div class="text-center text-muted py-4">
                        No payroll data available for the selected period.
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    export default
    {
        mounted() {
        },
        props: ['payrunsfiscalyear','payrunsfiscalmonth'],
        components: {
        },
        data()
        {

            return {

                year_segment1:'',
                year_segment2:'',
                search_doughnut:{employee_id:'', pay_slip_name:'', pay_slip_ref:'', fiscal_year:'', month:''},
                doughnutDatas: null,
                options_doughnut:null,
                myStyles_doughnut:null,
                payrunsapproved:[],
                quick_start_load:false,
                load_data:'Please hold tight! We are generating your payroll stat!',
                draft_payruns:[],
                 // new added from here
                analysis_percentages: { basic: '0.0', house: '0.0', medical: '0.0', pf: '0.0' },
                 // new added from here upto this point
            }
        },
        methods:
        {
            setSearchDoughnut: function(pageflg)
            {
                this.getpayrunsapproveddoughnut();
            },
            doughnutData(basic_salary,house_rent,conveyance_allowance,medical_allowance,total_additions,pf_contribution)
            {
                this.doughnutDatas = {
                  labels: ['Basic Salary', 'House Rent Allowance' ,'Medical Allowance', 'PF Contribution'],
                  datasets: [{
                    label: 'My First Dataset',
                    data: [basic_salary,house_rent,medical_allowance,pf_contribution],
                    borderColor: ['#BAEDBD', '#C6C7F8','#76C9D3','#3A52A5'], // Add custom color border
                    backgroundColor: ['#BAEDBD', '#C6C7F8','#76C9D3','#3A52A5'], // Add custom color background (Points and Fill)
                    borderWidth: 5, // Specify bar border width
                    borderRadius:10,
                    spacing:10,
                    offset:10,
                    hoverOffset: 4
                  }]
                };

                // new added from here
                let total = basic_salary + house_rent + medical_allowance + pf_contribution;
                this.analysis_percentages = {
                    basic: total > 0 ? ((basic_salary / total) * 100).toFixed(1) : '0.0',
                    house: total > 0 ? ((house_rent / total) * 100).toFixed(1) : '0.0',
                    medical: total > 0 ? ((medical_allowance / total) * 100).toFixed(1) : '0.0',
                    pf: total > 0 ? ((pf_contribution / total) * 100).toFixed(1) : '0.0',
                };

                this.options_doughnut = { /* unchanged */ };
                this.myStyles_doughnut = { /* unchanged */ };
                // new added from here upto this point

                this.options_doughnut =
                {
                    responsive: true, // Instruct chart js to respond nicely.
                    maintainAspectRatio: true, // Add to prevent default behaviour of full-width/height
                    cutoutPercentage: 85, // Add to prevent default behaviour of full-width/height
                    legend: {
                        display: false
                    },
                    tooltips: {
                        callbacks: {
                            title: function(tooltipItem, data) {
                                return data['labels'][tooltipItem[0]['index']];
                            },
                            label: function(tooltipItem, data) {
                                return data['datasets'][0]['data'][tooltipItem['index']].toLocaleString();
                            },
                        },
                    }
                };

                this.myStyles_doughnut={
                    height: '100%',
                    width: '100%',
                    position: 'relative',

                };
            },
            getpayrunsapproveddoughnut: function()
            {
                let year = '';
                let month = '';

                if(this.search_doughnut.fiscal_year==''){

                    //('getpayrunsapproveddoughnut 0');
                    axios.get(this.$api_url+'/list-payruns-fiscalyear/0' , {
                    params: {

                      }
                    }).then(function(response){

                        year = response.data.data[0].fiscal_year;
                        month = this.search_doughnut.month;

                        var yr=year.split("-"); //at_edit
                        this.year_segment1=yr[0];
                        this.year_segment2=yr[1];
                        //console.log('getpayrunsapproveddoughnut 1');
                        axios.get(this.$api_url+'/list-payruns/1' , {
                            params: {
                                search_query: { fiscal_year:year,month:month},

                            }
                        }).then(function(response){
                                this.payrunsapproveddoughnut2 = response.data.data;
                                this.doughnut_length = this.payrunsapproveddoughnut2.length;

                          }.bind(this));

                    }.bind(this));
                }

               // console.log('getpayrunsapproveddoughnut 2');
                this.doughnut_loader = true;
                this.search_doughnut.type = 'pie_chart';
               // console.log(this.search_doughnut.type);
                axios.get(this.$api_url+'/list-payruns/1' , {
                    params: {
                        search_query: this.search_doughnut,

                    }
                }).then(function(response){
                        this.payrunsapproveddoughnut = response.data.data;
                        //console.log(this.payrunsapproveddoughnut.length);
                        this.search_doughnut.type = '';




                        var a = 0;
                        var b = 0;
                        var c = 0;
                        var d = 0;
                        var e = 0;
                        var f = 0;

                       // console.log('payrunsapproveddoughnut length');
                       // console.log(this.payrunsapproveddoughnut.length);


                        if(this.payrunsapproveddoughnut.length > 0 ){   ///&& this.payrunsapproveddoughnut.length < this.doughnut_length
                            var mon = this.payrunsapproveddoughnut[0].month;
                            var yea = this.payrunsapproveddoughnut[0].year;
                            for (let y in this.payrunsapproveddoughnut) {
                                if(this.payrunsapproveddoughnut[y].month == mon && this.payrunsapproveddoughnut[y].year == yea ){
                                    a = a + parseFloat(this.payrunsapproveddoughnut[y].basic_salary.replaceAll(',', ''));
                                    b = b + parseFloat(this.payrunsapproveddoughnut[y].house_rent.replaceAll(',', ''));
                                    c = c + parseFloat(this.payrunsapproveddoughnut[y].conveyance_allowance.replaceAll(',', ''));
                                    d = d + parseFloat(this.payrunsapproveddoughnut[y].medical_allowance.replaceAll(',', ''));
                                    e = e + parseFloat(this.payrunsapproveddoughnut[y].total_additions.replaceAll(',', ''));
                                    f = f + parseFloat(this.payrunsapproveddoughnut[y].pf_contribution.replaceAll(',', ''));
                                }

                            }


                            let basic_salary = a;
                            let house_rent =  b;
                            let conveyance_allowance =  c;
                            let medical_allowance=  d;
                            let total_additions =   e;
                            let pf_contribution =  f;

                            // console.log('basic_salary');
                            // console.log(basic_salary);

                            // console.log('house_rent');
                            // console.log(house_rent);

                            // console.log('conveyance_allowance');
                            // console.log(conveyance_allowance);

                            // console.log('medical_allowance');
                            // console.log(medical_allowance);

                            // console.log('total_additions');
                            // console.log(total_additions);

                            // console.log('pf_contribution');
                            // console.log(pf_contribution);



                            this.doughnutData(basic_salary,house_rent,conveyance_allowance,medical_allowance,total_additions,pf_contribution);

                        }
                        else{

                        //     let gross = gross_draft + parseFloat(this.payrunsapproveddoughnut[0].earnings.replaceAll(',', ''));
                        //     let other_allowenecs = other_draft + parseFloat(this.payrunsapproveddoughnut[0].additions.replaceAll(',', ''));
                        //     let total = total_earnings_draft + parseFloat(this.payrunsapproveddoughnut[0].total_earnings.replaceAll(',', ''));
                        //     let deduction= deduction_draft + parseFloat(this.payrunsapproveddoughnut[0].deductions.replaceAll(',', ''));
                        //     let net = net_draft + parseFloat(this.payrunsapproveddoughnut[0].total_pay.replaceAll(',', ''));

                        // this.doughnutData(gross,other_allowenecs,total,deduction,net);

                          // new added from here
                        this.doughnutDatas = null;
                        this.analysis_percentages = { basic: '0.0', house: '0.0', medical: '0.0', pf: '0.0' };
                         // new added from here upto this point

                        }

                        this.doughnut_loader = false;

                        /*let gross = gross_draft + parseFloat(this.payrunsapproveddoughnut[0].earnings.replaceAll(',', ''));
                        let other_allowenecs = other_draft + parseFloat(this.payrunsapproveddoughnut[0].additions.replaceAll(',', ''));
                        let total = total_earnings_draft + parseFloat(this.payrunsapproveddoughnut[0].total_earnings.replaceAll(',', ''));
                        let deduction= deduction_draft + parseFloat(this.payrunsapproveddoughnut[0].deductions.replaceAll(',', ''));
                        let net = net_draft + parseFloat(this.payrunsapproveddoughnut[0].total_pay.replaceAll(',', ''));*/




                  }.bind(this));



            },
        },
        created: function(){
            if(this.payrunsfiscalyear.length > 0)
            {
                console.log(this.payrunsfiscalmonth);
                this.search_doughnut.fiscal_year=this.payrunsfiscalyear[0].fiscal_year;
                this.search_doughnut.month = this.payrunsfiscalmonth[0];

                var yr = this.payrunsfiscalyear[0].fiscal_year.split("-");
                    this.year_segment1 = yr[0];
                    this.year_segment2 = yr[1];

                    this.getpayrunsapproveddoughnut();
                }
        }
    }
</script>
